import assignmentService from 'ApiService/Teacher/Assignment';
import DateField from 'components/fields/dateField';
import Nodatafound from 'pages/Common/Nodatafound';
import { formatDate } from 'pages/helpers/dateUtils';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';

const Index = () => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [filters, setFilters] = useState({
    type: 'all',
    createdDate: '',
    assignmentSchedule: '',
  });
  const [noData, setNoData] = useState(false);

  const formatDateForAPI = (dateString) => {
    if (!dateString) return undefined;

    if (dateString.includes('/')) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month}-${day}`;
    }

    return dateString;
  };

  const handleFilterChange = (key, value) => {
    if (key === 'createdDate' || key === 'scheduledDate') {
      const formattedDate = formatDateForAPI(value);
      console.log('Formatted date:', formattedDate);
      setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
    } else {
      setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
    }
  };
  const handleResetFilters = () => {
    setFilters({
      type: 'all',
      createdDate: '',
      assignmentSchedule: '',
    });
  };
  const handleTestClick = (testItem) => {
    setSelectedTest(testItem);
  };

  const handleBackClick = () => {
    setSelectedTest(null);
  };
  const fetchTests = async () => {
    setLoading(true);
    setNoData(false);
    try {
      const formattedFilters = {
        type: filters.type !== 'all' ? filters.type : undefined,
        createdAt: formatDateForAPI(filters.createdDate),
        scheduledAt: formatDateForAPI(filters.scheduledDate),
        assignmentSchedule: filters.assignmentSchedule || undefined,
      };

      console.log('Fetching with filters:', formattedFilters);

      const response = await assignmentService.getAllAssignment(
        formattedFilters
      );

      if (response.data.success && response.data.data.length > 0) {
        const filteredTests = response.data.data.filter((test) => {
          const matchesCreatedDate =
            !formattedFilters.createdAt ||
            test.createdAt.split('T')[0] === formattedFilters.createdAt;

          const matchesScheduledDate =
            !formattedFilters.scheduledAt ||
            test.scheduledAt.split('T')[0] === formattedFilters.scheduledAt;

          return matchesCreatedDate && matchesScheduledDate;
        });

        setTests(filteredTests);
        setNoData(filteredTests.length === 0);
      } else {
        setTests([]);
        setNoData(true);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch tests.');
      setTests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTests();
  }, [filters]);

  return (
    <div className="mt-4 h-full w-full rounded-[20px] md:mt-5">
      {selectedTest ? (
        <div className="p-4">
          {/* Test Details */}
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
            {selectedTest.title} - {selectedTest.type.toUpperCase()}
          </h3>
          <p className="text-gray-700 dark:text-gray-400">
            Course: {selectedTest.department}
          </p>
          <p className="text-gray-700 dark:text-gray-400">
            Completion Time: {selectedTest.completionTime}
          </p>
          <p className="text-gray-700 dark:text-gray-400">
            Total Marks: {selectedTest.totalMarks}
          </p>
          {selectedTest.questions.map((question, qIndex) => (
            <div
              key={qIndex}
              className="mt-4 rounded-lg bg-white p-4 shadow-md dark:bg-gray-800"
            >
              <h5 className="text-lg font-bold text-gray-900 dark:text-white">
                Question {qIndex + 1}: {question.questionText}
              </h5>
              <ul className="mt-2">
                {question.options.map((option, optIndex) => (
                  <li
                    key={optIndex}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    {optIndex + 1}. {option}
                  </li>
                ))}
              </ul>
              <p className="mt-2 text-green-600 dark:text-green-400">
                Correct Answer: {question.correctAnswer}
              </p>
              {question.marks && (
                <p className="mt-2 text-blue-600 dark:text-blue-400">
                  Marks: {question.marks}
                </p>
              )}
            </div>
          ))}
          <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            <button
              onClick={handleBackClick}
              className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
            >
              Back
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="mb-4 flex flex-row space-x-4 text-navy-800">
            <div className="w-full md:w-1/5">
              <label className="ml-3 text-sm font-bold text-navy-800 dark:text-white">
                Assignment Type
              </label>
              <select
                value={filters.type}
                onChange={(e) => handleFilterChange('type', e.target.value)}
                className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
              >
                <option value="all">Assignment Type</option>
                <option value="mcq">MCQ</option>
                <option value="qa">QA</option>
              </select>
            </div>

            <div className="w-full md:w-1/5">
              <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                Schedule Type
              </label>
              <select
                value={filters.assignmentSchedule}
                onChange={(e) =>
                  handleFilterChange('assignmentSchedule', e.target.value)
                }
                className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
              >
                <option value="">Assignment Schedule</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="end assignment">End Assignment</option>
              </select>
            </div>

            <div className="w-full md:w-1/5">
              <DateField
                label="Created Date"
                type="date"
                value={filters.createdDate}
                onChange={(e) =>
                  handleFilterChange('createdDate', e.target.value)
                }
                className="rounded-lg bg-gray-200 px-4 py-2 text-gray-700 dark:bg-gray-800 dark:text-gray-300"
              />
            </div>

            <div className="w-full md:w-1/5">
              <DateField
                label="Scheduled Date"
                type="date"
                value={filters.scheduledDate}
                onChange={(e) =>
                  handleFilterChange('scheduledDate', e.target.value)
                }
                className="rounded-lg bg-gray-200 px-4 py-2 text-gray-700 dark:bg-gray-800 dark:text-gray-300"
              />
            </div>

            <div className="flex w-full items-end justify-end md:w-1/5">
              <button
                onClick={handleResetFilters}
                className="linear cursor-pointer rounded-xl bg-brand-900 px-9 py-3 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
              >
                Reset Filters
              </button>
            </div>
          </div>

          {/* Test List */}
          {loading ? (
            <div className="flex h-40 items-center justify-center">
              <BallTriangle color="#5431ed" />
            </div>
          ) : noData ? (
            <div className="flex h-40 items-center justify-center dark:text-gray-600">
              <Nodatafound title="No assignment found" />
            </div>
          ) : (
            <div className="grid h-full max-h-[68vh] w-full grid-cols-1  gap-4 overflow-hidden overflow-y-scroll rounded-xl border border-gray-200 p-2 dark:border-white/10 md:grid-cols-2 lg:grid-cols-3">
              {tests.map((test) => (
                <div
                  key={test._id}
                  onClick={() => handleTestClick(test)}
                  className="cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none hover:border-brand-500 dark:border-[#323B5D] dark:!bg-navy-900 dark:bg-navy-900 dark:text-white"
                >
                  <div className="w-full p-4">
                    <h5 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
                      {test.title}
                    </h5>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                      Course: {test.department}
                    </p>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                      Assignment Type: {test.type || 'Not Scheduled Yet'}
                    </p>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                      Assignment Schedule:{' '}
                      {test.assignmentSchedule || 'Not Scheduled Yet'}
                    </p>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                      Total Questions: {test.questions.length}
                    </p>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                      Created At: {formatDate(test.createdAt || '')}
                    </p>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                      Scheduled At: {formatDate(test.scheduledAt || 'n/a')}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Index;
